import type { SaturatedOilViscosityParameters } from "../../d";

export function saturatedOilViscosityCalculator(
  params: SaturatedOilViscosityParameters
): {
  a: number;
  b: number;
  saturatedOilViscosity: number;
} {
  const { solutionGasRso, deadOilViscosity } = params;
  // Q34: =10.715*(J12+100)**-0.515
  const a = 10.715 * (solutionGasRso + 100) ** -0.515;

  // Q36: =5.44*(J12+150)**-0.338
  const b = 5.44 * (solutionGasRso + 150) ** -0.338;

  // Q38: =Q34*Q17**Q36
  const saturatedOilViscosity = a * deadOilViscosity ** b;

  return {
    a,
    b,
    saturatedOilViscosity
  };
}
